import { render, staticRenderFns } from "./TeamDeleteModal.vue?vue&type=template&id=3732e5d0&"
import script from "./TeamDeleteModal.vue?vue&type=script&lang=js&"
export * from "./TeamDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports